import React, { useRef } from "react";
import SheetBox from "./SheetBox";
import Silhouette from "./Silhouette";
import { uid } from "@/lib/defaultTemplate";

export default function SheetCanvas({ sheet, onChange, editMode, readOnly, shareToken }) {
  const ref = useRef(null);
  if (!sheet) return null;
  const { boxes = [], silhouette, canvas = { width: 1200, height: 1200 } } = sheet;

  const noop = () => {};
  const updateBox = readOnly ? noop : (id, next) => {
    onChange({ ...sheet, boxes: boxes.map((b) => (b.id === id ? next : b)) });
  };
  const deleteBox = readOnly ? noop : (id) => onChange({ ...sheet, boxes: boxes.filter((b) => b.id !== id) });
  const cloneBox = readOnly ? noop : (id) => {
    const b = boxes.find((x) => x.id === id);
    if (!b) return;
    onChange({ ...sheet, boxes: [...boxes, { ...b, id: uid(), x: b.x + 24, y: b.y + 24, title: b.title + " (Copy)" }] });
  };
  const renameBox = readOnly ? noop : (id, title) => updateBox(id, { ...boxes.find((b) => b.id === id), title });

  // Auto-extend canvas height if a box stretches below
  const maxY = Math.max(canvas.height, ...boxes.map((b) => b.y + b.h + 40), (silhouette?.y || 0) + (silhouette?.h || 0) + 40);

  return (
    <div className="relative w-full overflow-auto" data-testid="sheet-canvas-wrapper">
      <div
        ref={ref}
        className="relative mx-auto my-6 grain rounded-2xl border border-[#212A3E] bg-[#0a0f1c]/60"
        style={{ width: canvas.width, height: maxY, backgroundImage: "radial-gradient(rgba(212,175,55,0.05) 1px, transparent 1px)", backgroundSize: "24px 24px" }}
        data-testid="sheet-canvas"
      >
        {silhouette && (
          <Silhouette
            silhouette={silhouette}
            readOnly={readOnly}
            shareToken={shareToken}
            onChange={readOnly ? noop : (next) => onChange({ ...sheet, silhouette: next })}
          />
        )}
        {boxes.map((b) => (
          <SheetBox
            key={b.id}
            box={b}
            isIdentity={b.type === "identity"}
            editMode={editMode}
            readOnly={readOnly}
            onChange={(next) => updateBox(b.id, next)}
            onClone={() => cloneBox(b.id)}
            onDelete={() => deleteBox(b.id)}
            onRename={(title) => renameBox(b.id, title)}
            canvasRef={ref}
          />
        ))}
      </div>
    </div>
  );
}
